import { EntityField, EntityType, FieldType } from '../../app/services/entities/entity-type.class';
import { allPheFields, allPlanningFields } from '../common-entity-fields';

export const entityTypes: Record<string, EntityType> = {
    set: {
        key: 'set',
        name: 'Set',
        plural_name: 'Sets',
        icon: null,
        afas_name: 'GM Asfaltmachine',
        order: 4,
        is_team: false,
        has_realisations: true,
        has_driver: false,
        has_lowloader: true,
        has_truck: true,
        has_preferred_team: false,
        has_employees: false,
        has_default_performer: false,
        has_default_asphalt_performer: false,
        force_wide: false,
        visible_overview: false,
        visible_transport: true,
        visible_small: false,
        belongs_to: null,
        fields_planning_data: {
            ander_json_veld: {
                name: 'Aantal verkeersregelaars',
                type: FieldType.Number,
                validators: {
                    min: 0,
                    max: 9999,
                    required: true,
                },
            },
        } as { ander_json_veld: EntityField },
        fields_planning: {
            contractor: {
                name: 'Opdrachtgever',
                type: FieldType.Text,
                validators: {
                    minLength: 0,
                    maxLength: 9999,
                    required: true,
                },
            },
            traffic_controllers: {
                name: 'Aantal verkeersregelaars',
                type: FieldType.Number,
                validators: {
                    min: 0,
                    max: 9999,
                    required: true,
                },
            },
            ander_json_veld: {
                name: 'Aantal verkeersregelaars',
                type: FieldType.Number,
                validators: {
                    min: 0,
                    max: 9999,
                    required: true,
                },
            },
            size: {
                name: 'Grootte',
                type: FieldType.Select,
                options: [
                    {
                        name: 'Groot',
                        key: 'large',
                    },
                    {
                        name: 'Middel',
                        key: 'medium',
                    },
                ],
                required: true,
                icon: null,
            },
        },
        fields_phe: {
            testphe: {
                name: 'Aantal verkeersregelaars',
                type: FieldType.Number,
                validators: {
                    min: 0,
                    max: 9999,
                    required: true,
                },
            },
        },
        fields_phe_data: {
            testphedata: {
                name: 'Aantal verkeersregelaars',
                type: FieldType.Number,
                validators: {
                    min: 0,
                    max: 9999,
                    required: true,
                },
            },
        },
        multi_select: false,
    },
    cutter: {
        key: 'cutter',
        name: 'Frees',
        plural_name: 'Frezen',
        icon: null,
        afas_name: 'GM Frees',
        order: 10,
        is_team: false,
        has_realisations: true,
        has_driver: true,
        has_lowloader: true,
        has_truck: true,
        has_preferred_team: false,
        has_employees: false,
        has_default_performer: false,
        has_default_asphalt_performer: false,
        force_wide: false,
        visible_overview: true,
        visible_transport: true,
        visible_small: false,
        belongs_to: null,
        fields_planning: allPlanningFields,
        fields_phe: allPheFields,
        multi_select: false,
    },
    wipeTruck: {
        key: 'wipeTruck',
        name: 'Veeg\/zuigwagen',
        plural_name: 'Veeg-\/zuigwagens',
        icon: null,
        afas_name: 'GM Veeg-zuig',
        order: 16,
        is_team: false,
        has_realisations: true,
        has_driver: true,
        has_lowloader: true,
        has_truck: true,
        has_preferred_team: false,
        has_employees: false,
        has_default_performer: false,
        has_default_asphalt_performer: false,
        force_wide: false,
        visible_overview: true,
        visible_transport: true,
        visible_small: false,
        belongs_to: null,
        fields_planning: allPlanningFields,
        fields_phe: allPheFields,
        multi_select: false,
    },
    truck: {
        key: 'truck',
        name: 'Vrachtwagen',
        plural_name: 'Vrachtwagens',
        icon: null,
        afas_name: 'Vrachtwagen',
        order: 25,
        is_team: false,
        has_realisations: true,
        has_driver: true,
        has_lowloader: true,
        has_truck: false,
        has_preferred_team: true,
        has_employees: false,
        has_default_performer: false,
        has_default_asphalt_performer: false,
        force_wide: false,
        visible_overview: false,
        visible_transport: true,
        visible_small: false,
        belongs_to: null,
        fields_planning: allPlanningFields,
        fields_phe: allPheFields,
        multi_select: true,
    },
    asfaltTeam: {
        key: 'asfaltTeam',
        name: 'Asfaltploeg',
        plural_name: 'Asfaltploegen',
        icon: 'fa-duotone fa-people-group',
        afas_name: null,
        order: 1,
        is_team: true,
        has_realisations: false,
        has_driver: false,
        has_lowloader: true,
        has_truck: false,
        has_preferred_team: false,
        has_employees: true,
        has_default_performer: false,
        has_default_asphalt_performer: true,
        force_wide: true,
        visible_overview: false,
        visible_transport: false,
        visible_small: false,
        belongs_to: null,
        fields_planning: allPlanningFields,
        fields_phe: allPheFields,
        multi_select: false,
    },
    dumper: {
        key: 'dumper',
        name: 'Dumper',
        plural_name: 'Dumpers',
        icon: null,
        afas_name: 'Wieldumper',
        order: 18,
        is_team: false,
        has_realisations: true,
        has_driver: false,
        has_lowloader: false,
        has_truck: false,
        has_preferred_team: true,
        has_employees: false,
        has_default_performer: false,
        has_default_asphalt_performer: false,
        force_wide: false,
        visible_overview: false,
        visible_transport: true,
        visible_small: true,
        belongs_to: null,
        fields_planning: allPlanningFields,
        fields_phe: allPheFields,
        multi_select: false,
    },
    hirePeople: {
        key: 'hirePeople',
        name: 'Inhuur mensen',
        plural_name: 'Inhuur mensen',
        icon: null,
        afas_name: null,
        order: 20,
        is_team: false,
        has_realisations: true,
        has_driver: false,
        has_lowloader: false,
        has_truck: false,
        has_preferred_team: false,
        has_employees: false,
        has_default_performer: false,
        has_default_asphalt_performer: false,
        force_wide: false,
        visible_overview: false,
        visible_transport: false,
        visible_small: false,
        belongs_to: null,
        fields_planning: allPlanningFields,
        fields_phe: allPheFields,
        multi_select: false,
    },
    lowLoader: {
        key: 'lowLoader',
        name: 'Dieplader',
        plural_name: 'Diepladers',
        icon: null,
        afas_name: 'Dieplader',
        order: 19,
        is_team: false,
        has_realisations: true,
        has_driver: false,
        has_lowloader: false,
        has_truck: true,
        has_preferred_team: false,
        has_employees: false,
        has_default_performer: false,
        has_default_asphalt_performer: false,
        force_wide: false,
        visible_overview: false,
        visible_transport: true,
        visible_small: false,
        belongs_to: null,
        fields_planning: allPlanningFields,
        fields_phe: allPheFields,
        multi_select: false,
    },
    projectTeam: {
        key: 'projectTeam',
        name: 'Projectploeg',
        plural_name: 'Projectploegen',
        icon: 'fa-duotone fa-person-digging',
        afas_name: null,
        order: 2,
        is_team: true,
        has_realisations: false,
        has_driver: false,
        has_lowloader: false,
        has_truck: false,
        has_preferred_team: false,
        has_employees: true,
        has_default_performer: true,
        has_default_asphalt_performer: false,
        force_wide: true,
        visible_overview: false,
        visible_transport: false,
        visible_small: false,
        belongs_to: null,
        fields_planning: allPlanningFields,
        fields_phe: allPheFields,
        multi_select: false,
    },
    preparationTeam: {
        key: 'preparationTeam',
        name: 'Voorbereidingsploeg',
        plural_name: 'Voorbereidingsploegen',
        icon: 'fa-duotone fa-road-circle-check',
        afas_name: null,
        order: 3,
        is_team: true,
        has_realisations: false,
        has_driver: false,
        has_lowloader: false,
        has_truck: false,
        has_preferred_team: false,
        has_employees: true,
        has_default_performer: true,
        has_default_asphalt_performer: false,
        force_wide: true,
        visible_overview: false,
        visible_transport: false,
        visible_small: false,
        belongs_to: null,
        fields_planning: allPlanningFields,
        fields_planning_data: null,
        fields_phe: allPheFields,
        multi_select: false,
        fields_phe_data: null,
    },
    asfaltTruck: {
        key: 'asfaltTruck',
        name: 'Asfalttruck',
        plural_name: 'Asfalttrucks',
        icon: null,
        afas_name: 'Vrachtwagen',
        order: 5,
        is_team: false,
        has_realisations: true,
        has_driver: true,
        has_lowloader: true,
        has_truck: false,
        has_preferred_team: true,
        has_employees: false,
        has_default_performer: false,
        has_default_asphalt_performer: false,
        force_wide: false,
        visible_overview: false,
        visible_transport: true,
        visible_small: false,
        belongs_to: null,
        fields_planning: allPlanningFields,
        fields_phe: allPheFields,
        multi_select: false,
    },
    cutterTruck: {
        key: 'cutterTruck',
        name: 'Freestruck',
        plural_name: 'Freestrucks',
        icon: null,
        afas_name: 'Vrachtwagen',
        order: 11,
        is_team: false,
        has_realisations: true,
        has_driver: true,
        has_lowloader: true,
        has_truck: false,
        has_preferred_team: true,
        has_employees: false,
        has_default_performer: false,
        has_default_asphalt_performer: false,
        force_wide: false,
        visible_overview: false,
        visible_transport: true,
        visible_small: false,
        belongs_to: 'asfaltTeam',
        fields_planning: allPlanningFields,
        fields_phe: allPheFields,
        multi_select: false,
    },
    shovel: {
        key: 'shovel',
        name: 'Shovel',
        plural_name: 'Shovels',
        icon: null,
        afas_name: 'GM Shovel',
        order: 50,
        is_team: false,
        has_realisations: true,
        has_driver: false,
        has_lowloader: false,
        has_truck: false,
        has_preferred_team: false,
        has_employees: false,
        has_default_performer: false,
        has_default_asphalt_performer: false,
        force_wide: false,
        visible_overview: false,
        visible_transport: false,
        visible_small: true,
        belongs_to: null,
        fields_planning: allPlanningFields,
        fields_phe: allPheFields,
        multi_select: false,
    },
    crane: {
        key: 'crane',
        name: 'Kraan',
        plural_name: 'Kranen',
        icon: null,
        afas_name: 'GM Kraan',
        order: 51,
        is_team: false,
        has_realisations: true,
        has_driver: true,
        has_lowloader: true,
        has_truck: true,
        has_preferred_team: true,
        has_employees: false,
        has_default_performer: false,
        has_default_asphalt_performer: false,
        force_wide: false,
        visible_overview: false,
        visible_transport: true,
        visible_small: true,
        belongs_to: null,
        fields_planning: allPlanningFields,
        fields_phe: allPheFields,
        multi_select: false,
    },
    roller: {
        key: 'roller',
        name: 'Wals',
        plural_name: 'Walsen',
        icon: null,
        afas_name: 'GM Wals',
        order: 52,
        is_team: false,
        has_realisations: true,
        has_driver: false,
        has_lowloader: false,
        has_truck: false,
        has_preferred_team: true,
        has_employees: false,
        has_default_performer: false,
        has_default_asphalt_performer: false,
        force_wide: false,
        visible_overview: false,
        visible_transport: false,
        visible_small: false,
        belongs_to: 'asfaltTeam',
        fields_planning: allPlanningFields,
        fields_phe: allPheFields,
        multi_select: false,
    },
    golfCart: {
        key: 'golfCart',
        name: 'Golfkar',
        plural_name: 'Golfkarren',
        icon: null,
        afas_name: 'Golfkar',
        order: 53,
        is_team: false,
        has_realisations: true,
        has_driver: false,
        has_lowloader: false,
        has_truck: false,
        has_preferred_team: false,
        has_employees: false,
        has_default_performer: false,
        has_default_asphalt_performer: false,
        force_wide: false,
        visible_overview: false,
        visible_transport: false,
        visible_small: false,
        belongs_to: null,
        fields_planning: allPlanningFields,
        fields_phe: allPheFields,
        multi_select: false,
    },
    shack: {
        key: 'shack',
        name: 'Keet',
        plural_name: 'Keten',
        icon: null,
        afas_name: 'Snelverkeer keet',
        order: 54,
        is_team: false,
        has_realisations: true,
        has_driver: false,
        has_lowloader: false,
        has_truck: false,
        has_preferred_team: true,
        has_employees: false,
        has_default_performer: false,
        has_default_asphalt_performer: false,
        force_wide: false,
        visible_overview: false,
        visible_transport: false,
        visible_small: false,
        belongs_to: null,
        fields_planning: allPlanningFields,
        fields_phe: allPheFields,
        multi_select: false,
    },
    asphaltOther: {
        key: 'asphaltOther',
        name: 'Asfalt overig',
        plural_name: 'Asfalt overigen',
        icon: null,
        afas_name: 'GM Asfalt overig',
        order: 60,
        is_team: false,
        has_realisations: true,
        has_driver: false,
        has_lowloader: true,
        has_truck: true,
        has_preferred_team: true,
        has_employees: false,
        has_default_performer: false,
        has_default_asphalt_performer: false,
        force_wide: false,
        visible_overview: false,
        visible_transport: true,
        visible_small: true,
        belongs_to: null,
        fields_planning: allPlanningFields,
        fields_phe: allPheFields,
        multi_select: false,
    },
    other: {
        key: 'other',
        name: 'Overig',
        plural_name: 'Overigen',
        icon: null,
        afas_name: 'GM Overig',
        order: 61,
        is_team: false,
        has_realisations: true,
        has_driver: false,
        has_lowloader: false,
        has_truck: false,
        has_preferred_team: false,
        has_employees: false,
        has_default_performer: false,
        has_default_asphalt_performer: false,
        force_wide: false,
        visible_overview: false,
        visible_transport: false,
        visible_small: true,
        belongs_to: null,
        fields_planning: allPlanningFields,
        fields_phe: allPheFields,
        multi_select: false,
    },
    stickyWagon: {
        key: 'stickyWagon',
        name: 'Kleefwagen',
        plural_name: 'Kleefwagens',
        icon: null,
        afas_name: 'GM Asfalt kleef',
        order: 55,
        is_team: false,
        has_realisations: true,
        has_driver: true,
        has_lowloader: false,
        has_truck: false,
        has_preferred_team: true,
        has_employees: false,
        has_default_performer: false,
        has_default_asphalt_performer: false,
        force_wide: false,
        visible_overview: false,
        visible_transport: true,
        visible_small: false,
        belongs_to: null,
        fields_planning: allPlanningFields,
        fields_phe: allPheFields,
        multi_select: false,
    },
    trailer: {
        key: 'trailer',
        name: 'Aanhangwagen',
        plural_name: 'Aanhangwagen',
        icon: null,
        afas_name: 'Aanhangwagen',
        order: 99999,
        is_team: false,
        has_realisations: true,
        has_driver: false,
        has_lowloader: false,
        has_truck: false,
        has_preferred_team: false,
        has_employees: false,
        has_default_performer: false,
        has_default_asphalt_performer: false,
        force_wide: false,
        visible_overview: false,
        visible_transport: false,
        visible_small: false,

        belongs_to: null,
        fields_planning: allPlanningFields,
        fields_phe: allPheFields,
        multi_select: false,
    },
    containerShed: {
        key: 'containerShed',
        name: 'Container \/ keet',
        plural_name: 'Container \/ keet',
        icon: null,
        afas_name: 'Container \/ keet',
        order: 99999,
        is_team: false,
        has_realisations: true,
        has_driver: false,
        has_lowloader: false,
        has_truck: false,
        has_preferred_team: true,
        has_employees: false,
        has_default_performer: false,
        has_default_asphalt_performer: false,
        force_wide: false,
        visible_overview: false,
        visible_transport: false,
        visible_small: false,
        belongs_to: null,
        fields_planning: allPlanningFields,
        fields_phe: allPheFields,
        multi_select: false,
    },
    vibratingPlate: {
        key: 'vibratingPlate',
        name: 'Trilplaat',
        plural_name: 'Trilplaat',
        icon: null,
        afas_name: 'Trilplaat',
        order: 99999,
        is_team: false,
        has_realisations: true,
        has_driver: false,
        has_lowloader: false,
        has_truck: false,
        has_preferred_team: true,
        has_employees: false,
        has_default_performer: false,
        has_default_asphalt_performer: false,
        force_wide: false,
        visible_overview: false,
        visible_transport: false,
        visible_small: false,
        belongs_to: null,
        fields_planning: allPlanningFields,
        fields_phe: allPheFields,
        multi_select: false,
    },
    vkm: {
        key: 'vkm',
        name: 'VKM',
        plural_name: 'VKM',
        icon: null,
        afas_name: 'VKM',
        order: 99999,
        is_team: false,
        has_realisations: true,
        has_driver: true,
        has_lowloader: false,
        has_truck: false,
        has_preferred_team: true,
        has_employees: false,
        has_default_performer: false,
        has_default_asphalt_performer: false,
        force_wide: false,
        visible_overview: false,
        visible_transport: false,
        visible_small: false,
        belongs_to: null,
        fields_planning: allPlanningFields,
        fields_phe: allPheFields,
        multi_select: false,
    },
    hiringStaff: {
        key: 'hiringStaff',
        name: 'Inhuur personeel',
        plural_name: 'Inhuur personeel',
        icon: null,
        afas_name: null,
        order: 100,
        is_team: false,
        has_realisations: true,
        has_driver: false,
        has_lowloader: false,
        has_truck: false,
        has_preferred_team: false,
        has_employees: false,
        has_default_performer: false,
        has_default_asphalt_performer: false,
        force_wide: false,
        visible_overview: false,
        visible_transport: false,
        visible_small: true,
        belongs_to: null,
        fields_planning: allPlanningFields,
        fields_phe: allPheFields,
        multi_select: false,
    },
    rentalEquipment: {
        key: 'rentalEquipment',
        name: 'Inhuur materieel',
        plural_name: 'Inhuur materieel',
        icon: null,
        afas_name: null,
        order: 100,
        is_team: false,
        has_realisations: true,
        has_driver: false,
        has_lowloader: false,
        has_truck: false,
        has_preferred_team: false,
        has_employees: false,
        has_default_performer: false,
        has_default_asphalt_performer: false,
        force_wide: false,
        visible_overview: false,
        visible_transport: false,
        visible_small: true,
        belongs_to: null,
        fields_planning: allPlanningFields,
        fields_phe: allPheFields,
        multi_select: false,
    },
    standardCostCenter: {
        key: 'standardCostCenter',
        name: 'Standaard kostenplaats',
        plural_name: 'Standaard kostenplaats',
        icon: null,
        afas_name: 'Standaard kostenplaats',
        order: 99999,
        is_team: false,
        has_realisations: true,
        has_driver: false,
        has_lowloader: false,
        has_truck: false,
        has_preferred_team: false,
        has_employees: false,
        has_default_performer: false,
        has_default_asphalt_performer: false,
        force_wide: false,
        visible_overview: false,
        visible_transport: false,
        visible_small: false,
        belongs_to: null,
        fields_planning: allPlanningFields,
        fields_phe: allPheFields,
        multi_select: false,
    },
    vkmMaterial: {
        key: 'vkmMaterial',
        name: 'VKM materiaal',
        plural_name: 'VKM materialen',
        icon: null,
        afas_name: null,
        order: 62,
        is_team: false,
        has_realisations: true,
        has_driver: false,
        has_lowloader: false,
        has_truck: false,
        has_preferred_team: false,
        has_employees: false,
        has_default_performer: false,
        has_default_asphalt_performer: false,
        force_wide: false,
        visible_overview: false,
        visible_transport: false,
        visible_small: false,
        belongs_to: null,
        fields_planning: allPlanningFields,
        fields_phe: allPheFields,
        multi_select: false,
    },
    vkmPreparation: {
        key: 'vkmPreparation',
        name: 'VKM voorbereiding',
        plural_name: 'VKM voorbereidingen',
        icon: null,
        afas_name: null,
        order: 63,
        is_team: false,
        has_realisations: true,
        has_driver: false,
        has_lowloader: false,
        has_truck: false,
        has_preferred_team: false,
        has_employees: false,
        has_default_performer: false,
        has_default_asphalt_performer: false,
        force_wide: false,
        visible_overview: false,
        visible_transport: false,
        visible_small: false,
        belongs_to: null,
        fields_planning: allPlanningFields,
        fields_phe: allPheFields,
        multi_select: false,
    },
    vkmWorkOrder: {
        key: 'vkmWorkOrder',
        name: 'VKM Werkopdracht',
        plural_name: 'VKM Werkopdrachten',
        icon: null,
        afas_name: null,
        order: 64,
        is_team: false,
        has_realisations: true,
        has_driver: false,
        has_lowloader: false,
        has_truck: false,
        has_preferred_team: false,
        has_employees: false,
        has_default_performer: false,
        has_default_asphalt_performer: false,
        force_wide: false,
        visible_overview: false,
        visible_transport: false,
        visible_small: false,
        belongs_to: null,
        fields_planning: allPlanningFields,
        fields_phe: allPheFields,
        multi_select: false,
    },
    passengerCar: {
        key: 'passengerCar',
        name: 'Personenauto',
        plural_name: "Personenauto's",
        icon: null,
        afas_name: null,
        order: 67,
        is_team: false,
        has_realisations: true,
        has_driver: false,
        has_lowloader: false,
        has_truck: false,
        has_preferred_team: false,
        has_employees: false,
        has_default_performer: false,
        has_default_asphalt_performer: false,
        force_wide: false,
        visible_overview: false,
        visible_transport: false,
        visible_small: false,
        belongs_to: null,
        fields_planning: allPlanningFields,
        fields_phe: allPheFields,
        multi_select: false,
    },
};
